import {
  authSetUser,
  updateBrandColor,
  authClearUser,
} from "../actions/authAction";
import { PRIMARY_HEX } from "../../theme/primary";
/**
 *
 * @param {*} state
 * @param {*} action
 * @return {*}
 *
 *
 */
const brandColor = PRIMARY_HEX;
function r(
  state = { authenticated: false, isLoggedIn: false, brandColor },
  action,
) {
  switch (action.type) {
    case authSetUser.type:
      return {
        ...state,
        isLoggedIn: true,
        authenticated: true,
        userId: action.payload?._id,
        email: action.payload?.email,
      };

    case authClearUser.type:
      return {
        ...state,
        isLoggedIn: false,
        authenticated: false,
        userId: null,
        email: null,
      };

    // case setUserData.type:
    //   return {
    //     ...state,
    //     userId: action.payload?._id,
    //     email: action.payload?.email,
    //     name: action.payload.name,
    //     phone: action.payload.phoneNumber
    //   };

    case updateBrandColor.type:
      return {
        ...state,
        brandColor: action.payload?.brandColor,
      };

    // case toggleState.type:
    //   return {
    //     ...state,
    //     newState: action.payload,
    //   };
    default:
      return state;
  }
}

export default r;
